import React from 'react';
import { Modal, Box, Typography, FormGroup, FormControlLabel, Checkbox, Button, Divider, RadioGroup, Radio } from '@mui/material';

const cardLabels = {
  resultado: 'Base Geral de Pacientes',
  impostos: 'Conversão de Orçamentos',
  fluxo: 'Aniversariantes do Mês',
  despesas: 'Top Procedimentos (Valor)',
  dre: 'Fluxo de Pacientes (Mês)',
  lancamentos: 'Retenção Ativa (Alertas +6 meses)'
};

const SettingsModalClinica = ({ open, onClose, numColunas, cardsVisiveis, onSave }) => {
  const [localNumColunas, setLocalNumColunas] = React.useState(numColunas);
  const [localCardsVisiveis, setLocalCardsVisiveis] = React.useState(cardsVisiveis);

  React.useEffect(() => {
    setLocalNumColunas(numColunas);
    setLocalCardsVisiveis(cardsVisiveis);
  }, [numColunas, cardsVisiveis, open]);

  const handleCheckboxChange = (card) => {
    setLocalCardsVisiveis({ ...localCardsVisiveis, [card]: !localCardsVisiveis[card] });
  };

  const handleColChange = (e) => {
    setLocalNumColunas(Number(e.target.value));
  };

  const handleSave = () => {
    onSave(localNumColunas, localCardsVisiveis);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        minWidth: 340,
        maxWidth: 400
      }}>
        <Typography variant="h6" sx={{ mb: 2 }}>Configurações do Dashboard da Clínica</Typography>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Cards Visíveis</Typography>
        <FormGroup>
          {Object.keys(cardLabels).map((card) => (
            <FormControlLabel
              key={card}
              control={<Checkbox checked={!!localCardsVisiveis[card]} onChange={() => handleCheckboxChange(card)} />}
              label={cardLabels[card]}
            />
          ))}
        </FormGroup>
        <Divider sx={{ my: 2 }} />
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Colunas</Typography>
        <RadioGroup row value={localNumColunas} onChange={handleColChange}>
          <FormControlLabel value={1} control={<Radio />} label="1" />
          <FormControlLabel value={2} control={<Radio />} label="2" />
          <FormControlLabel value={3} control={<Radio />} label="3" />
        </RadioGroup>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 1 }}>
          <Button onClick={onClose} color="secondary">Cancelar</Button>
          <Button onClick={handleSave} variant="contained">Salvar</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SettingsModalClinica;
